<p-colorPicker [formControl]="control()" appendTo="body" />